export const buildOutlinePath = (
  width: number,
  height: number,
  radius: number,
  activeLeft: number | null,
  activeWidth: number | null,
  // How far to bleed the baseline past x=0 / width so it reaches the visual
  // edge of the bar even when the SVG sits inside a padded scroll container
  // (mobile has px-[14px]). Desktop's SVG is full-width, so it passes 0.
  edgeInset: number = 0,
): string => {
  const h = height
  const r = radius
  if (activeLeft === null || activeWidth === null) {
    return `M ${-edgeInset} ${h} L ${width + edgeInset} ${h}`
  }
  const right = activeLeft + activeWidth
  // Extend the baseline out to the container edge only when the active tab's
  // foot actually sits inside the container. When the tab is flush against an
  // edge (the first tab on mobile, or the last tab at the scroll end) the foot
  // is at/past the edge, so a baseline segment there would run backwards and
  // poke out — omit it. Keyed on geometry, not tab index, so the first/last
  // desktop tabs (which have padding to the edge) still get a full baseline.
  const hasLeftBaseline = activeLeft - r > 0
  const hasRightBaseline = right + r < width
  return [
    hasLeftBaseline
      ? `M ${-edgeInset} ${h} L ${activeLeft - r} ${h}`
      : `M ${activeLeft - r} ${h}`,
    `A ${r} ${r} 0 0 0 ${activeLeft} ${h - r}`,
    `L ${activeLeft} ${r}`,
    `A ${r} ${r} 0 0 1 ${activeLeft + r} 0`,
    `L ${right - r} 0`,
    `A ${r} ${r} 0 0 1 ${right} ${r}`,
    `L ${right} ${h - r}`,
    `A ${r} ${r} 0 0 0 ${right + r} ${h}`,
    hasRightBaseline ? `L ${width + edgeInset} ${h}` : '',
  ]
    .filter(Boolean)
    .join(' ')
}
